import { render } from "./TableButton.vue?vue&type=template&id=08cb23e0"
import script from "./TableButton.vue?vue&type=script&lang=js"
export * from "./TableButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/ideal-ventures/ideal-hr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__